var AT_Slider ={

      owlSlider : function(){
        jQuery(".menu-proudct-carousel").length && jQuery(".menu-proudct-carousel").owlCarousel({
              nav: true,
              dots: false,
              items: 1,
              margin : 0,
              navText: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });

      	jQuery(".big-product .image-list").length && jQuery('.big-product .image-list').owlCarousel({
          	nav			: true
          	,dots 		: false
          	,items		: 1
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });

      	jQuery(".image-carousel").length && jQuery('.image-carousel').owlCarousel({
          	nav			: true
          	,dots 		: false
          	,items		: 1
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });
        
        jQuery('.big-image-thumbs').owlCarousel({
          nav     		: false
          ,dots  	 	: false
          ,items 		: 4
          ,margin 		: 0
          ,responsive 	: {
            0:{
              items: 3
            }
            ,480:{
              items: 3
            }
            ,768:{
              items: 4
            }
          }
        });

      	jQuery(".catalog-list").length && jQuery('.catalog-list').owlCarousel({
          	nav			: true
          	,dots 		: false
          	,items		: 3
          	,margin		: 30
			      ,responsive : {
              	0:{
                	items: 1
                }
            	,480:{
              		items: 2
            	}
                ,992:{
              		items: 3
                  	,nav	: false
            	}
          	}
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
        });

      	setTimeout(function(){
          jQuery(".service-list-item").length && jQuery('.service-list-item').owlCarousel({
          	nav			: true
          	,dots 		: false
          	,margin		: 0
			,responsive : {
              	0:{
                	items: 1
                }
            	,768:{
              		items: 2
            	}
              	,980:{
              		items: 3
            	}
                ,1024:{
              		items: 4
            	}
              	,1180:{
              		items: 6
                    ,nav	: false
                  	,autoWidth	: true
                  	,mouseDrag	: false
            	}
          	}
          	,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']
          });
        }, 1200);

      	jQuery(".gallery-image-thumb").length && jQuery('.gallery-image-thumb').owlCarousel({
            nav			: true
          	,dots 		: false
          	,margin		: 0
          	,mouseDrag	: false
          	,items    	: 6
			,responsive : {
              0:{
                items: 3
              }
              ,480:{
                items: 3
              }
              ,768:{
                items: 4
              }
              ,992:{
                items: 4
              }
              ,1024:{
                items: 6
              }
          	}
			,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']

        });

      	jQuery(".logo-list").length && jQuery('.logo-list').owlCarousel({
            nav			: false
          	,dots 		: true
          	,margin		: 30
          	,mouseDrag	: false
			,responsive : {
                0:{
                	items: 2
                }
              	,480:{
                	items: 3
                }
              	,768:{
                	items: 4
                }
              	,992:{
                	items: 5
                }
          	}
			,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']

        });

      	jQuery(".type-testimonial .testimonial").length && jQuery('.type-testimonial .testimonial').owlCarousel({
            nav			: true
          	,dots 		: false
			,items		: 1
			,navText	: ['<span class="button-prev"></span>', '<span class="button-next"></span>']

        });

	}

  	,init : function(){
      this.owlSlider();
    }

}

/* Check IE */
var bcMsieVersion = {

  MsieVersion: function() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else                 // If another browser, return 0
      {
      return 0;
    }
  }

  ,init : function(){
    this.MsieVersion();
  }
}

jQuery.fn.extend({
  scrollToMe: function() {
    if (jQuery(this).length) {
      var top = jQuery(this).offset().top - 200;
      jQuery('html,body').animate({
        scrollTop: top
      }, 500);
    }
  },
});;

function addCart(){
  AT_Main.fixNoScroll();
  $('.cart-sb').toggleClass('opened');
  $('html,body').toggleClass('cart-opened');
}

function notifyAddCartFail($i){
  $.jGrowl($i,{
    life: 3000,
    position:'center'
  });
}

/* Ajax Add To Cart */

function addToCart(e){
  if (typeof e !== 'undefined') e.preventDefault();
  $('.loading').css("display","block");
  var $this = $(this);

  $this.addClass('disabled');

  var form = $this.parents('form');

  // Hide Modal
  $('.modal').modal('hide');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: true,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });
}

function addToCartSuccess (jqXHR, textStatus, errorThrown){
  $('.add-to-cart').removeClass('disabled');
  $('.loading').css("display","none");
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  var product_name  = jqXHR.product_title
  ,product_image = jqXHR.image
  ,product_price = jqXHR.price
  ,product_quantity = jqXHR.quantity
  , product_variant = jqXHR.variant_title
  ,product_total_price = product_quantity * product_price;


  
    $('#layer-addcart-modal .addcart-modal-title').html(product_name);
    $('#layer-addcart-modal .addcart-modal-image').html('<img src="'+ Shopify.resizeImage(product_image,'220x') +'" alt="'+ product_name +'">');
    $('#layer-addcart-modal .addcart-modal-variant').html(product_variant);
    $('#layer-addcart-modal .addcart-modal-qty').html('<strong>Quantity:</strong>'+product_quantity+'');
    $('#layer-addcart-modal .addcart-modal-price').html('<strong>Total:</strong>'+ Shopify.formatMoney(product_total_price, _bc_config.money_format));
    $('#layer-addcart-modal').addClass('show');

  	// jQuery('body,html').animate({scrollTop:0},800,'swing');

  

  // Get the cart show in the cart box.
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '#cart-info #cart-content');
  });

  
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);

  var $i = '<div class="error">'+ response.description +'</div>';
  notifyAddCartFail($i);
  $(this).removeClass('disabled');
  $('.add-to-cart').removeClass('disabled');
  $('.loading').css("display","none");
}

function addcartModalHide(){
  $("#layer-addcart-modal").addClass("zoomOut animated").fadeOut();
  $("#layer-addcart-modal").removeClass("zoomOut animated");
}

jQuery(document).ready(function($) {
  AT_Slider.init();
  
 	 $("body").on( 'click','.add-to-cart', addToCart );
  
})